'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoFileBinary = function GoFileBinary(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 37.5v-35h22.5l7.5 7.5v27.5h-30z m27.5-25l-7.5-7.5h-17.5v30h25v-22.5z m-15 7.5h-7.5v-10h7.5v10z m-2.5-7.5h-2.5v5h2.5v-5z m0 17.5h2.5v2.5h-7.5v-2.5h2.5v-5h-2.5v-2.5h5v7.5z m10-12.5h2.5v2.5h-7.5v-2.5h2.5v-5h-2.5v-2.5h5v7.5z m2.5 15h-7.5v-10h7.5v10z m-2.5-7.5h-2.5v5h2.5v-5z' })
        )
    );
};

exports.default = GoFileBinary;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/file-binary.js
// module id = 1908
// module chunks = 0